import { render, staticRenderFns } from "./GrpMbrManage.vue?vue&type=template&id=840a1790&"
import script from "./GrpMbrManage.vue?vue&type=script&lang=js&"
export * from "./GrpMbrManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports